import styles from './price.module.scss';

function Price(props: { price: number; showMembershipPeriodText?: boolean; membershipPeriodText?: string }) {
    const defaultMembershipPeriodText = 'Prisen gjelder per medlemskapsår';
    return (
        <>
            <div className={styles.price}>{props.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} kr</div>
            {props.showMembershipPeriodText && (
                <div className={styles.membershipPeriod}>
                    {props.membershipPeriodText ? props.membershipPeriodText : defaultMembershipPeriodText}
                </div>
            )}
        </>
    );
}

export default Price;
